export let navLinks = [
    { linkText: "Sohum Gupta", href: "/", outerText: ""},
    // { linkText: "Projects", href: "/projects", outerText: "├── "},
    { linkText: "Writing", href: "/writing", outerText: "├── "},
    // { linkText: "Food", href: "/writing#food", outerText: "│\u00a0\u00a0\u00a0\u00a0├── "},
    // { linkText: "Creative", href: "/writing#creative", outerText: "│\u00a0\u00a0\u00a0\u00a0├── "},
    // { linkText: "Misc.", href: "/writing#misc", outerText: "│\u00a0\u00a0\u00a0\u00a0└── "},
    { linkText: "Photography", href: "/photography", outerText: "├── "},
    { linkText: "About", href: "/about", outerText: "└── "},
    // { linkText: "Bio", href: "/about#bio", outerText: "\u00a0\u00a0\u00a0\u00a0\u00a0├── "},
    // { linkText: "Contact", href: "/about#contact", outerText: "\u00a0\u00a0\u00a0\u00a0\u00a0├── "},
    { linkText: "Resume", href: "/about/resume", outerText: "\u00a0\u00a0\u00a0\u00a0\u00a0└── "},
]

export let navPhotoAlbums = [
    { linkText: "Oahu", href: "/photography/oahu", outerText: "│\u00a0\u00a0\u00a0\u00a0├── "},
    { linkText: "Amsterdam", href: "/photography/amsterdam", outerText: "│\u00a0\u00a0\u00a0\u00a0├── "},
    { linkText: "Berlin", href: "/photography/berlin", outerText: "│\u00a0\u00a0\u00a0\u00a0├── "},
    { linkText: "Copenhagen", href: "/photography/copenhagen", outerText: "│\u00a0\u00a0\u00a0\u00a0├── "},
    // { linkText: "Arizona", href: "/photography/arizona", outerText: "│\u00a0\u00a0\u00a0\u00a0├── "},
    { linkText: "Ghana", href: "/photography/ghana", outerText: "│\u00a0\u00a0\u00a0\u00a0├── "},
    { linkText: "New England", href: "/photography/new%20england", outerText: "│\u00a0\u00a0\u00a0\u00a0├── "},
    { linkText: "Cancun", href: "/photography/cancun", outerText: "│\u00a0\u00a0\u00a0\u00a0├── "},
    { linkText: "Florida", href: "/photography/florida", outerText: "│\u00a0\u00a0\u00a0\u00a0├── "},
    // { linkText: "Illinois", href: "/photography/illinois", outerText: "│\u00a0\u00a0\u00a0\u00a0├── "},
    { linkText: "San Francisco", href: "/photography/san%20francisco", outerText: "│\u00a0\u00a0\u00a0\u00a0├── "},
    { linkText: "Quebec City", href: "/photography/quebec%20city", outerText: "│\u00a0\u00a0\u00a0\u00a0└── "},
]